module.exports = __webpack_public_path__ + "img/rdi.22a09bbc.png";